import notify from 'devextreme/ui/notify'
import React, { useState, useEffect, createContext, useContext, useCallback } from 'react'
import { getCountNextEvents, getUserAgrDogovors } from '../api/agrdog'
import { getUser, signIn as sendSignInRequest, logout, generateFingerpint, syncUser, getSyncStatus } from '../api/auth'
import { getCountVistSf, getUserDogovors } from '../api/dogovor'
import { getCountNotReads } from '../api/point'
import {getCountNotReaded, getParamsFromResource, getRequestTypes} from '../api/request'
import StorageService from './../services/storage.service'
import {getCookie, setCookie} from "../utils/cookie";
import { fetchReadsSubmitPeriod, isReadsSubmitDeadlineApproaching } from "../utils/reads-submit-period";

function AuthProvider(props) {
  const [user, setUser] = useState()
  const [dogovors, setUserDogovors] = useState([])
  const [agrDogovors, setAgrDogovors] = useState([])
  const [selectedAgrdog, setSelectedAgrdog] = useState()
  const [reqTypes, setReqTypes] = useState([])
  const [selectedDog, setSelectedDog] = useState(StorageService.getLocalDogovor())
  const [auth, setAuth] = useState(StorageService.getLocalAuth())
  const [loading, setLoading] = useState(true)
  const [navigationLoading, setNavigationLoading] = useState(!!StorageService.getLocalAuth())
  const [lettersCount, setLettersCount] = useState(0)
  const [nextAgrEventsCount, setNextAgrEvents] = useState(0)
  const [countDogovors, setCountDogovors] = useState(0)
  const [countNotReads, setCountNotReads] = useState(0)
  const [countVistSf, setCountVistSf] = useState(0)
  const [loadSyncUser, setLoadSyncUser] = useState(false)
  const [syncInFlight, setSyncInFlight] = useState(false)
  const [navigation, setNavigation] = useState([])
  const [topNavigation, setTopNavigation] = useState([])
  const [fileLimits, setfileLimits] = useState({})
  const [timerWorks, setTimerWorks] = useState(false)
  const timeout = 120000
  const [newMenu, setNewMenu] = useState(true)
  const [impersonate, setImpersonate] = useState();

  const extracted = useCallback(async (res_dogovors, selectDogovor, lastUser, res_user) => {
    const listUserDogs = res_dogovors.data
    let localDog = StorageService.getLocalDogovor()
    // если есть договор в хранилище, сравниваем с списком. Если в полученных его нет, заменяем первым из списка
    if (localDog) {
      const dog = listUserDogs.find(e => e.kodDog === localDog.kodDog)
      if (!dog && listUserDogs.length > 0) {
        localDog = listUserDogs[0]
        StorageService.setLocalDogovor(listUserDogs[0])
      }
    }
    setUserDogovors(listUserDogs)
    const isLocalDogActual = (listUserDogs && localDog && listUserDogs.find(dog => dog.kodDog === localDog.kodDog))
    if (!isLocalDogActual) {
      StorageService.removeLocalDodovor()
      localDog = null
    }
    selectDogovor =
        (localDog && (lastUser?.id === res_user.data.id) && isLocalDogActual) ? //если есть последний договор и зашли под тем же пользователем И не удаляли договор из связок
            listUserDogs.find(dog => dog.kodDog === localDog.kodDog) ://localDog : //показываем последний выбранный //теперь заменяю договор на случай его изменения
            (listUserDogs && listUserDogs.length > 0) ? //если не выбирали раньше, но есть подвязанные договора
                listUserDogs[0] : //показываем первый из подключенных в списке
                null //если нет подключенных договоров
    setSelectedDog(selectDogovor)
    if (selectDogovor) StorageService.setLocalDogovor(selectDogovor)
    else StorageService.removeLocalDodovor()

    //region ЛИШНИЙ КОД


    //получаем типы заявок
    const res_types = await getRequestTypes()
    if (res_types.isOk) {
      setReqTypes(res_types.data)
    } else {
      notify(res_types.message, 'error', 5000)
    }



    //FILE_LIMITS
    const res_fl = await getParamsFromResource('FILE_LIMITS')
    if (res_fl.isOk) {
      setfileLimits(JSON.parse(res_fl.data))
    } else {
      notify(res_fl.message, 'error', 5000)
    }

    //запомним последнего пользователя
    StorageService.setLocalUser(res_user.data)

    //кол-во непрочитанных сообщений для стикера
    const countLettersData = await getCountNotReaded()
    if (countLettersData.isOk) {
      setLettersCount(countLettersData.data.letters)
    } else {
      notify(countLettersData.message,'error',5000)
    }

    //получим агрегированные договора пользователя
    const agrRes = await getUserAgrDogovors()
    if (agrRes.isOk) {
      const resDogovors = agrRes.data
      setAgrDogovors(resDogovors)
      const localAgrDog = StorageService.getLocalAgrDogovor()
      let selectedAgrDog = ((localAgrDog && (lastUser?.id === res_user.data.id)) ? //если есть последний договор и зашли под тем же пользователем
              resDogovors.find(dog => dog.kodDog === localAgrDog.kodDog) ://localAgrDog : //показываем последний выбранный
              (resDogovors && resDogovors.length > 0) ? //если не выбирали раньше, но есть подвязанные договора
                  resDogovors[0] : //показываем первый из подключенных в списке
                  null //если нет подключенных договоров
      )
      setSelectedAgrdog(selectedAgrDog)
      if (selectedAgrDog) StorageService.setLocalAgrDogovor(selectedAgrDog)
      else StorageService.removeLocalAgrDodovor()
    } else {
      notify(agrRes.message, 'error',5000)
    }

    //посчитаем кол-во не наступивших событий по агрегатору
    const agrCountRes = await getCountNextEvents()
    if (agrCountRes.isOk) {
      setNextAgrEvents(agrCountRes.data)
    } else {
      notify(agrCountRes.message, 'error',5000)
    }

    //посчитаем кол-во документов к оплате по всем договорам
    if (selectDogovor !== null) {
      const resData = await getCountVistSf(selectDogovor.kodDog)
      if (resData.isOk) {
        setCountVistSf(resData.data)
      } else {
        notify(resData.message,'error',5000)
      }
    }

    //endregion
    return selectDogovor;
  },[])

  useEffect(() => {
    (async function () {
      if (auth){
        //MENU_NAVIGATION
        let navString = '';
        let topNavString = '';
        let newMenu = true;
        const res = await getParamsFromResource('MENU_NAVIGATION_UNION');
        if (res.isOk && res.data) {
          navString = res.data;
        } else {
          const res2 = await getParamsFromResource('MENU_NAVIGATION');
          if (res2.isOk) {
            newMenu = false;
            navString = res2.data;
          } else {
            notify(res2.message,'error',5000);
          }
        }

        try {
          if (newMenu) {
            topNavString = (JSON.parse(navString))[1].UPPER_MENU;
            navString = (JSON.parse(navString))[0].LEFT_MENU;
          } else{
            navString = JSON.parse(navString);
          }
        } catch (e) {
          navString = navString
              .replace(/\n/gs, '')
              .replace(/\r/gs, '')
              .replace(/ {2,}/gs, '')
              .replace(/\{ ?([^:]+):/gs, '{"$1":')
              .replace(/, ?([^:{]+):/gs, ',"$1":')
          if (!navString) {
            setNavigationLoading(false)
            return
          }
          if (newMenu) {
            const parsedNav = JSON.parse(navString)
            navString = parsedNav[0].LEFT_MENU;
            topNavString = parsedNav[1].UPPER_MENU;
          } else {
            navString = JSON.parse(navString)
          }
        }
        if (+selectedDog?.parameter_uk === +null){
          navString.forEach((e) => {
            if (e.text === "Показания") {
              e.items.forEach((i, index2) => {
                if (i.text === "Показания УК"){
                  e.items.splice(index2,1)
                }
              })
            }
          })
        }
        setNavigation(navString)
        newMenu && setTopNavigation(topNavString)
        setNewMenu(newMenu)
      }
      setNavigationLoading(false)
    })()
  }, [selectedDog, auth])

  useEffect(() => {
    let timoutId
    let timerId
    (async function () {
      try {
        if (auth){
          //получаем пользователя
          const res_user = await getUser()
          if (res_user.isOk) {
            setUser(res_user.data)
            const lastUser = StorageService.getLocalUser()
            //получаем договора пользователя (Договор уже есть в БД)
            let res_dogovors = await getUserDogovors()
            if (res_dogovors.isOk && (process.env.REACT_APP_NAME_ENV !== 'tatenergosbyt' || res_dogovors.data.length > 0)) {
              await extracted(res_dogovors, null, lastUser, res_user);
            } else if (res_dogovors.isOk && res_dogovors.data.length === 0 && process.env.REACT_APP_NAME_ENV === 'tatenergosbyt') {

              // мессага про активацию договора
              setTimerWorks(getCookie('timerWorks') !== "true")
              setCookie('timerWorks', true, {'max-age': 60 * 60 * 24 * 365 * 10})//10лет

              await extracted({isOk:true, data:[]}, null, lastUser, res_user);
              timerId = setInterval(async () => {
                console.log(`tick timer - ${timerId} -- Время ${getTime()}`);
                let res_dogovors = await getUserDogovors()
                if (res_dogovors.isOk && res_dogovors.data.length > 0) {
                  clearInterval(timerId)
                  setTimerWorks(false)
                  console.log('stop - ' + timerId);
                  await extracted(res_dogovors, null, lastUser, res_user);
                  notify(`Список договоров обновлен.`, 'success', 5000);
                }
              }, 5000);
              //если не пришло ответа более timeout милисекунд киляем interval
              timoutId = setTimeout(async () => {
                clearInterval(timerId);
                setTimerWorks(false)
                console.log('stop - ' + timerId);
              }, timeout);
            } else {
              notify(res_dogovors.message, 'error', 5000)
              await extracted({isOk:true, data:[]}, null, lastUser, res_user);
            }
          } else {
            await logout()
          }
        }
      } catch (e) {
        notify(e.message, 'error', 5000)
      } finally {
        setLoading(false)
      }
    })()
    // Cleanup function
    return () => {
      if (timoutId) clearTimeout(timoutId); // Cancel the asynchronous task
      if (timerId) clearInterval(timerId);
    };
  }, [auth, extracted])

  useEffect(() => {
    (async function () {
      if (auth && selectedDog){
        //посчитаем кол-во точек без показаний в периоде, если срок передачи истекает
        const submitPeriod = await fetchReadsSubmitPeriod()
        if (isReadsSubmitDeadlineApproaching(submitPeriod)) {
          const countRes = await getCountNotReads(selectedDog.kodDog)
          if (countRes.isOk) {
            setCountNotReads(countRes.data.count)
          } else {
            notify(countRes.message,'error',5000)
          }
        }
      }
    })()
  }, [auth, selectedDog])

  useEffect(() => {
    setImpersonate(JSON.parse(window.localStorage.getItem("originalUser"))?.lastName);
  }, [user]);

  const refreshSyncStatus = useCallback(async () => {
    if (!auth) {
      setSyncInFlight(false)
      return false
    }
    const res = await getSyncStatus()
    const running = !!(res.isOk && res.running)
    setSyncInFlight(running)
    return running
  }, [auth])

  useEffect(() => {
    if (!auth) {
      setSyncInFlight(false)
      return
    }
    let cancelled = false
    ;(async () => {
      if (!cancelled) await refreshSyncStatus()
    })()
    return () => { cancelled = true }
  }, [auth, refreshSyncStatus])

  useEffect(() => {
    if (!auth || !syncInFlight) return
    const id = setInterval(() => {
      refreshSyncStatus()
    }, 3000)
    return () => clearInterval(id)
  }, [auth, syncInFlight, refreshSyncStatus])

  const syncUserData = useCallback(async (period_s = null, period_po = null) => {
    setLoadSyncUser(true)
    const res = await syncUser(selectedDog ? selectedDog.kodDog : null, period_s, period_po)
    if (res.isOk) {
      setSyncInFlight(true)
      const resUser = await getUser()
      if (resUser.isOk) {
        setUser(resUser.data)
      }
    } else {
      notify(res.message, 'error', 10000)
    }
    setLoadSyncUser(false)
    return res
  }, [selectedDog])

  const signIn = useCallback(async (email, password) => {
    const fingerprint = await generateFingerpint()
    const result = await sendSignInRequest(email, password, fingerprint)
    if (result.isOk) {
      setLoading(true)
      StorageService.setLocalAuth(fingerprint)
      setAuth(result.data)
      //console.log('in Context: ' + result.data.dogovors)
      setCountDogovors(result.data.dogovors)
      await syncUserData()
    }

    return result
  }, [syncUserData])

  const signOut = useCallback(async () => {
    await logout()
    setUser()
  }, [])

  const updateCountNotReads = useCallback(async (p_dogovor) => {
    if (p_dogovor === null) return
    const submitPeriod = await fetchReadsSubmitPeriod()
    if (isReadsSubmitDeadlineApproaching(submitPeriod)) {
      const countRes = await getCountNotReads(p_dogovor.kodDog)
      if (countRes.isOk) {
        setCountNotReads(countRes.data.count)
      } else {
        notify(countRes.message,'error',5000)
      }
    }
  }, [])

  const updateCountVistSf = useCallback(async (p_dogovor) => {
    if (p_dogovor !== null) {
      //посчитаем кол-во документов к оплате по всем договорам
      const resData = await getCountVistSf(p_dogovor.kodDog)
      if (resData.isOk) {
        setCountVistSf(resData.data)
      } else {
        notify(resData.message,'error',5000)
      }
    }
  }, [])

  function getTime(){
    let time = new Date();
    let formatter = new Intl.DateTimeFormat("ru", {
      hour: "numeric",
      minute: "numeric",
      second: "numeric"
    });
    return formatter.format(time)
  }

  //отдельно запустим синхронизацию при авторизации
  // useEffect(() => async function () {
  //   if (auth) syncUserData()
  // },[auth, syncUserData])

  return (
      <AuthContext.Provider value={{ user, setUser, dogovors, countDogovors, selectedDog, reqTypes, setSelectedDog, signIn, signOut, loading, navigationLoading,
        lettersCount, setLettersCount, agrDogovors, selectedAgrdog, setSelectedAgrdog, nextAgrEventsCount, countNotReads, setCountNotReads,
        updateCountNotReads, countVistSf, updateCountVistSf, syncUserData, loadSyncUser, syncInFlight, refreshSyncStatus, navigation, fileLimits, timerWorks, setTimerWorks,
        topNavigation, newMenu, setAuth, setCountDogovors, impersonate}} {...props} />
  )
}

const AuthContext = createContext({})
const useAuth = () => useContext(AuthContext)

export { AuthProvider, useAuth }
